
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Nonacbusrentalsserviceinpune() {



  const cardData =
  {
    keyword: ' Non AC Bus Rental Service in Pune',
    heading: 'Vaishnavi Travels: Non AC Bus Rental Service in Pune',
    headingDescription: 'Vaishnavi Travels offers budget-friendly and reliable Non AC Bus Rental Service in Pune, ideal for local travel, school trips, social gatherings, and group tours. Our non-AC buses are well-maintained, spacious, and comfortable, providing an economical solution for large group transportation without compromising on safety. With ample seating capacity, luggage space, and professional drivers, we ensure smooth and timely travel for every occasion. Whether it’s a family function, picnic, religious yatra, or corporate outing, Vaishnavi Travels delivers dependable non-AC bus rental services in Pune, making group journeys convenient and hassle-free at the best price.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Once the seat of power of the Maratha Empire, its mighty gates, sprawling gardens, and ruined bastions narrate tales of valor and glory. Though partially destroyed by a fire in 1828, the fort still stands as a majestic landmark. The evening light-and-sound show recreates the romance of Bajirao and Mastani and the grandeur of the Peshwas. Thousands of visitors explore its corridors, courtyards, and gardens every day. Shaniwar Wada remains Pune’s proud cultural and historic centerpiece."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument closely tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its majestic Italian arches, sprawling lawns, and colonial architecture make it a popular attraction. Tourists enjoy the calm and serene ambiance of its gardens while soaking in history. Aga Khan Palace stands as Pune’s inspirational monument of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 25 km from Pune, Sinhagad Fort is famous for the 1670 battle in which Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers panoramic views of the Sahyadris and trekking opportunities for adventure lovers. The fort is dotted with ancient bastions, temples, and memorials echoing Maratha bravery. In monsoon, mist and waterfalls add a magical touch to the trek. Local villagers serve traditional pithla-bhakri, making the trip even more authentic. Sinhagad is Pune’s perfect mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple is famous for its magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of vibrant celebrations attracting lakhs of devotees. Beyond rituals, the temple is renowned for its charitable, cultural, and social initiatives. Tourists and devotees alike experience the spiritual energy and grandeur here. Dagdusheth Ganpati is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, a sanctum, and a Nandi mandapa, it is a fine example of early Indian rock-cut architecture. Despite being located in the city center, the temple offers a peaceful and meditative environment. Evening prayers and chants fill the air with devotion and serenity. Tourists admire the craftsmanship and historical charm of this hidden heritage site. Pataleshwar Cave Temple is Pune’s spiritual retreat in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits range from musical instruments, sculptures, and ornaments to everyday household objects of past centuries. The recreated Mastani Mahal is a highlight that fascinates history lovers. Students and tourists find the museum both educational and inspiring. It preserves India’s cultural traditions and artistry across eras. Raja Dinkar Kelkar Museum is Pune’s proud celebration of heritage, history, and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city from its hilltop temple complex. The Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and museums nearby add cultural depth to the visit. Visitors climb 103 stone steps to reach the top, combining devotion with a healthy trek. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic escape above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort, located in Koregaon Park, is Pune’s global destination for spirituality, wellness, and mindfulness. Spread across beautifully landscaped gardens, it attracts seekers and tourists from across the world. The ashram offers meditation techniques, yoga practices, and personal growth workshops. Japanese Zen gardens and tranquil meditation halls create a serene atmosphere. Beyond spirituality, it promotes rejuvenation and holistic living. Osho Ashram is Pune’s international hub of peace, healing, and inner growth."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Inspired by the famous Korakuen Garden in Japan, Pu La Deshpande Garden is Pune’s largest landscaped park. It is designed with flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, peaceful walks, and photography in this lush setting. The garden is also a symbol of Indo-Japanese cultural friendship. Nature lovers find it refreshing throughout the year, especially in spring. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built across the Mutha River, is a popular weekend spot just outside Pune. It not only supplies water to the city but also offers stunning views of hills, backwaters, and sunsets. In monsoon, the overflowing dam creates breathtaking sights. Locals and tourists enjoy roadside snacks like roasted corn and tea along the banks. It is also the starting point for trips to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway for families and travelers alike."
  }
],


  "services": [
  {
    "name": "Non AC Bus Hire Pune",
    "description": "Reliable non-AC bus hire services in Pune offering comfortable and affordable transportation options for local and short-distance travel. Ideal for group outings, school trips, and budget-conscious travelers who seek dependable service without the extra cost of air conditioning."
  },
  {
    "name": "Budget Bus Rental Pune",
    "description": "Cost-effective bus rental solutions in Pune providing spacious, non-AC buses that deliver value without compromising on safety or comfort. Perfect for families, small groups, and organizations planning economical trips within and around the city."
  },
  {
    "name": "Non AC School Bus Hire",
    "description": "Safe and well-maintained non-AC school bus rental services in Pune designed specifically for daily school commutes and educational trips. Our buses prioritize child safety, punctuality, and professional drivers, making them a trusted choice for schools."
  },
  {
    "name": "Non AC Bus for Marriage",
    "description": "Affordable non-AC bus hire options for wedding events in Pune, suitable for transporting large groups of guests comfortably. These buses provide a practical choice for Baraats, receptions, and related functions where air conditioning is not a priority."
  },
  {
    "name": "Affordable Non AC Bus Service",
    "description": "Economical non-AC bus services catering to budget travelers and group trips in Pune. Our buses are regularly serviced and driven by experienced chauffeurs, ensuring a safe and reliable journey for every occasion."
  },
  {
    "name": "Non AC Bus for Tours Pune",
    "description": "Non-AC bus rentals perfect for sightseeing and group tours in Pune, providing ample seating and easy accessibility. Ideal for travelers looking for an affordable way to explore nearby attractions and heritage sites."
  },
  {
    "name": "Simple Bus Hire Pune",
    "description": "Straightforward and hassle-free non-AC bus hire service in Pune, designed for groups who need dependable transport without extra frills. Booking is quick, with flexible timing options and friendly customer support to assist you."
  },
  {
    "name": "Group Non AC Bus Rental",
    "description": "Group-friendly non-AC bus rental services in Pune, offering spacious seating and reliable transportation for large families, school groups, or corporate outings. Our buses are equipped to handle group logistics smoothly and safely."
  },
  {
    "name": "50 Seater Non AC Bus Pune",
    "description": "Spacious 50-seater non-AC buses available for rent in Pune, ideal for big group travels, school excursions, and event transport. These buses provide generous seating capacity at affordable rates without compromising safety or comfort."
  },
  {
    "name": "Event Non AC Bus Hire",
    "description": "Non-AC bus rentals for various events in Pune including weddings, religious functions, and corporate gatherings. Our event buses are punctual, clean, and operated by professional drivers to ensure smooth guest transportation."
  },
  {
    "name": "School Tour Non AC Bus Pune",
    "description": "Specialized non-AC bus services for school tours and field trips in Pune, ensuring safe and comfortable travel for students. Our buses comply with safety regulations and come with experienced drivers familiar with school tour requirements."
  },
  {
    "name": "Short Distance Bus Rental Pune",
    "description": "Affordable non-AC bus rental options for short-distance travel in Pune, perfect for quick group trips, local sightseeing, and day outings. Flexible booking options and prompt service make it easy to plan your transport needs."
  },
  {
    "name": "Non AC Wedding Guest Bus Pune",
    "description": "Budget-friendly non-AC bus rental service specifically for wedding guests in Pune. These buses provide reliable, comfortable transport for wedding events without the added cost of air conditioning, making guest travel efficient and economical."
  }
],
"tableData": [
  ["Non AC Bus Hire Pune", "Budget Bus Rental Pune"],
  ["Non AC School Bus Hire", "Non AC Bus for Marriage"],
  ["Affordable Non AC Bus Service", "Non AC Bus for Tours Pune"],
  ["Simple Bus Hire Pune", "Group Non AC Bus Rental"],
  ["50 Seater Non AC Bus Pune", "Event Non AC Bus Hire"],
  ["School Tour Non AC Bus Pune", "Short Distance Bus Rental Pune"],
  ["Non AC Wedding Guest Bus Pune"]
],




 "whychoose": [
  {
    "WhyChooseheading": "Affordable Non AC Bus Rental Service in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers budget-friendly non AC bus rentals in Pune, perfect for cost-effective group travel without compromising comfort."
  },
  {
    "WhyChooseheading": "Spacious Seating for Comfortable Journeys",
    "WhyChoosedescription": "Our non AC buses provide ample legroom and seating space, ensuring a comfortable ride for all passengers."
  },
  {
    "WhyChooseheading": "Regularly Maintained and Clean Buses",
    "WhyChoosedescription": "Each vehicle is thoroughly cleaned and serviced to maintain hygiene and reliability for your trips."
  },
  {
    "WhyChooseheading": "Flexible Rental Options to Suit Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental packages tailored to your travel plans and group size."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Expertise",
    "WhyChoosedescription": "Our professional drivers are well-versed with Pune’s routes, ensuring safe and timely transportation."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our all-inclusive pricing covers fuel, tolls, taxes, and driver allowance, providing a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for School Trips, Group Outings, and More",
    "WhyChoosedescription": "Perfect for economical travel needs such as school excursions, family outings, and group tours."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock support to help you with bookings and any travel-related queries."
  }
]





























  }









const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer non-AC bus rental services in Pune?',
      answer: 'Yes, Vaishnavi Travels provides reliable non-AC bus rental services across Pune. These buses are ideal for budget-conscious travelers who require comfortable and safe transportation without air conditioning.',
    },
    {
      question: 'What types of non-AC buses are available for rent?',
      answer: 'We offer a variety of non-AC buses, including 17-seater tempo travellers, 27 to 32-seater minibuses, and larger coaches. All our non-AC vehicles are well-maintained, clean, and designed to provide sufficient ventilation and comfort.',
    },
    {
      question: 'Are non-AC buses suitable for long-distance travel?',
      answer: 'Yes, our non-AC buses are regularly serviced and suitable for both short and long-distance journeys. Drivers are experienced and ensure a safe and smooth ride for all passengers.',
    },
    {
      question: 'How do non-AC bus rental prices compare to AC buses?',
      answer: 'Non-AC buses are generally more affordable compared to AC buses, making them an economical choice for groups traveling on a budget. Pricing depends on factors like bus size, duration, and distance.',
    },
    {
      question: 'Can I book non-AC buses for corporate events or school trips?',
      answer: 'Absolutely. Our non-AC bus rental services cater to a variety of needs including corporate events, school trips, picnics, and more. We tailor packages to match your specific requirements.',
    },
    {
      question: 'What safety measures are in place for non-AC buses?',
      answer: 'All our non-AC buses undergo regular maintenance checks and sanitization. Our drivers are trained professionals committed to ensuring passenger safety and comfort during the journey.',
    },
    {
      question: 'How can I book a non-AC bus rental in Pune?',
      answer: 'You can book easily through our website, mobile app, or by contacting our customer support team. Provide your travel details, group size, and preferred dates to receive customized options and pricing.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Sameer Patil",
    position: "Tour Coordinator",
    feedback:
      "We booked a non-AC bus from Vaishnavi Travels for our budget-friendly group trip, and the experience was excellent. The bus was clean, comfortable, and the driver was very professional and courteous. It was a cost-effective option without compromising on safety or comfort.",
    rating: 5,
  },
  {
    name: "Ms. Ritu Sharma",
    position: "School Administrator",
    feedback:
      "Vaishnavi Travels provided a well-maintained non-AC bus for our school field trip. The vehicle was spacious and ventilated, and the driver ensured a smooth and safe ride for all students. Their service was prompt and reliable, making them a trusted choice for our transportation needs.",
    rating: 5,
    style: "style-2",
  },
];










































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Non AC Bus Rental Service in Pune",
  "image": "https://vaishnavitravel.com/assets/images/non-ac-bus-rental-pune.jpg",
  "description": "Affordable Non AC bus rental services in Pune by Vaishnavi Travels. Ideal for school trips, weddings, tours, and events. Reliable 50-seater and group bus options with experienced drivers for your travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "1678"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3900",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/non-ac-bus-rental-service-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Non AC Bus Rental Service in Pune | Budget & Group Bus Hire | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Affordable Non AC bus rental services in Pune by Vaishnavi Travels. Ideal for school trips, weddings, tours, and events. Reliable 50-seater and group bus options with experienced drivers for your travel needs."
  />
  <meta
    name="keywords"
    content="Non AC Bus Hire Pune, Budget Bus Rental Pune, Non AC School Bus Hire, Non AC Bus for Marriage, Affordable Non AC Bus Service, Non AC Bus for Tours Pune, Simple Bus Hire Pune, Group Non AC Bus Rental, 50 Seater Non AC Bus Pune, Event Non AC Bus Hire, School Tour Non AC Bus Pune, Short Distance Bus Rental Pune, Non AC Wedding Guest Bus Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Nonacbusrentalsserviceinpune;